import React, { useState } from 'react';
import { Dialog } from '@headlessui/react';
import { X, AlertTriangle, Home, MapPin } from 'lucide-react';

export default function DeleteApartmentModal({ open, onClose, apartment, onConfirm }) {
  const [deleting, setDeleting] = useState(false);

  const handleDelete = async () => {
    setDeleting(true);
    try {
      await onConfirm();
      onClose();
    } catch (error) {
      console.error('Error in delete confirmation:', error);
    } finally {
      setDeleting(false);
    }
  };

  if (!apartment) return null;

  return (
    <Dialog open={open} onClose={onClose} className="fixed z-50 inset-0 flex items-center justify-center p-4">
      <div className="fixed inset-0 bg-black/30" aria-hidden="true" />
      <div className="relative bg-white rounded-2xl shadow-lg p-6 w-full max-w-lg mx-auto">
        <button
          className="absolute top-4 right-4 p-2 rounded-full hover:bg-zinc-100 text-zinc-500"
          onClick={onClose}
          disabled={deleting}
          aria-label="Stäng"
        >
          <X className="w-5 h-5" />
        </button>

        {/* Header */}
        <div className="flex items-start gap-4 mb-6">
          <div className="w-12 h-12 bg-red-100 rounded-full flex items-center justify-center flex-shrink-0">
            <AlertTriangle className="w-6 h-6 text-red-600" />
          </div>
          <div>
            <h2 className="text-xl font-bold text-[#222222] font-['Poppins']">
              Ta bort lägenhet från profil?
            </h2>
            <p className="text-sm text-[#626262] mt-1">
              Du kan lägga till den igen senare
            </p>
          </div>
        </div>

        {/* Apartment details */}
        <div className="space-y-3 mb-6 p-4 bg-gray-50 rounded-lg">
          <div className="flex items-center gap-2 text-sm text-[#222222]">
            <Home className="w-4 h-4 text-[#626262]" />
            <span className="font-semibold">Lägenhetsnummer:</span>
            <span>{apartment.apartmentNumber || 'Ej angiven'}</span>
          </div>

          <div className="flex items-center gap-2 text-sm text-[#222222]">
            <MapPin className="w-4 h-4 text-[#626262]" />
            <span className="font-semibold">Adress:</span>
            <span>{apartment.address || 'Ej angiven'}</span>
          </div>

          {apartment.housingCooperative && (
            <div className="flex items-center gap-2 text-sm text-[#222222]">
              <Home className="w-4 h-4 text-[#626262]" />
              <span className="font-semibold">Förening:</span>
              <span>{apartment.housingCooperative}</span>
            </div>
          )}
        </div>

        {/* Actions */}
        <div className="flex gap-3">
          <button
            onClick={onClose}
            disabled={deleting}
            className="flex-1 px-4 py-2.5 border border-[#E2EAF0] text-[#626262] rounded-lg font-semibold hover:bg-[#F9FCFF] transition-colors disabled:opacity-50"
          >
            Avbryt
          </button>
          <button
            onClick={handleDelete}
            disabled={deleting}
            className="flex-1 px-4 py-2.5 bg-red-500 text-white rounded-lg font-semibold hover:bg-red-600 transition-colors disabled:opacity-50"
          >
            {deleting ? 'Tar bort...' : 'Ta bort'}
          </button>
        </div>
      </div>
    </Dialog>
  );
}
